<template>
  <v-layout class="duplicate-segment">
    <template>
      <v-list-item :disabled="disabled">
        <v-list-item-title class="duplicate" @click="value = true">Duplicar</v-list-item-title>
      </v-list-item>
    </template>

    <v-dialog :value="value" width="480px" persistent>
      <v-card class="pa-2">
        <v-card-title>
          <span class="title">Qual será o nome do novo segmento?</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="name" />
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Criar',
              action: createInstantSegment,
              isVisible: true,
              isLoading: $wait.is('clone-segment'),
              isDisabled: isEmptyName,
            }"
            :extra-button="{
              text: 'Cancelar',
              action: closeDialog,
              isVisible: true,
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapWaitingActions } from 'vue-wait'

export default {
  props: {
    segmentChanges: Object,
    segmentId: String,
    disabled: Boolean,
  },
  data: () => ({
    value: false,
    name: 'Novo segmento',
  }),
  computed: {
    isEmptyName() {
      return !this.name.trim()
    },
  },
  methods: {
    ...mapWaitingActions({
      cloneSegment: 'clone-segment',
    }),

    createInstantSegment() {
      let segment = {
        id_segment: this.segmentId,
        name: this.name,
      }

      this.cloneSegment(segment)
        .then((response) => {
          const id = response.id_segment
          this.$router.push(`/clientes/segmentacao/editar/${id}`).catch(() => {})
        })
        .catch(() => {
          this.$snackbar({
            message: 'Erro ao duplicar segmento',
            snackbarColor: 'error',
          })
        })
    },
    closeDialog() {
      this.value = false
    },
  },
}
</script>

<style lang="scss">
.duplicate-segment {
  .duplicate {
    cursor: pointer;
  }
}
</style>
